import React from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from './Icon';

interface SidebarItemProps {
  path: string;
  icon: string;
  isCollapsed: boolean;
  children: React.ReactNode;
}

export const SidebarItem: React.FC<SidebarItemProps> = ({ 
  path, 
  icon, 
  isCollapsed, 
  children 
}) => {
  return (
      <li>
          <NavLink
              to={path}
              className={({ isActive }) =>
                  `flex items-center p-2 rounded-md transition-colors duration-200 h-10
          ${
              isActive
                  ? "bg-secondary text-white"
                  : "text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
          }`
              }
          >
              <div className="flex items-center min-w-[32px] justify-center">
                  <Icon name={icon} className="w-5 h-5" />
              </div>
              {!isCollapsed && (
                  <span className="ml-3 whitespace-nowrap overflow-hidden">
                      {children}
                  </span>
              )}
          </NavLink>
      </li>
  );
};
